module.exports = __webpack_public_path__ + "img/pyromaniac.71fc803d.png";